<template>
  <v-card
    flat
    class="px-0"
  >
    <v-card-text class="pa-0">
      <v-row class="justify-center align-center">
        <v-col
          v-for="image in images"
          :key="`image-${image.id}`"
          cols="12"
          sm="3"
        >
          <image-selection
            :title="image.title"
            :account-id="accountId"
            :value="image.value"
            @attach="image.value = $event"
          />
        </v-col>
      </v-row>

     
      <v-row
        v-if="formIns.themes"
        class="justify-start align-center pl-2"
      >
        <v-col
          cols="12"
          sm="2"
        >
          <v-switch
            v-model="formIns.themes.isDark"
            inset
            label="Default Dark"
          />
        </v-col>
        <v-col
          cols="12"
          sm="3"
          class="justify-start align-center pl-2"
        >
          <v-switch
            v-model="formIns.themes.allowChange"
            inset
            label="Allow Theme Change"
          />
        </v-col>
      </v-row>

    
      <v-row
        v-if="formIns.themes"
        class="align-center"
      >
        <v-col
          cols="12"
          class="d-flex justify-space-between align-center"
        >
          <div class="d-flex align-center">
            <v-tabs v-model="tab">
              <v-tab>Light Theme</v-tab>
              <v-tab>Dark Theme</v-tab>
            </v-tabs>
          </div>
          <v-btn
            color="green"
            class="white--text"
            small
            @click="$emit('enableDialog')"
          >
            <v-icon
              small
              class="pr-2"
            >
              mdi-palette
            </v-icon> Change theme
          </v-btn>
        </v-col>
      </v-row>

   
      <v-row v-if="formIns.themes">
        <v-col cols="12">
          <v-tabs-items v-model="tab">
            <v-tab-item>
              <v-card>
                <v-card-text>
                  <themes
                    :selected.sync="formIns.themes.light"
                    :set-default="enable"
                  />
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card>
                <v-card-text>
                  <themes
                    :selected.sync="formIns.themes.dark"
                    :set-default="enable"
                  />
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-col>
      </v-row>
    </v-card-text>

   
    <v-card-actions class="px-0">
      <v-spacer />
      <v-btn
        color="error"
        @click="close()"
      >
        Close
      </v-btn>
      <v-btn
        color="success"
        @click="save()"
      >
        Save
      </v-btn>
    </v-card-actions>
  </v-card>
</template>


<script>
const newFormIns = () => {
  return {
    name: "",
    themes: {
      id: "",
      light: {},
      dark: {},
      images: {
        logo: null,
        bg: null,
        home: null,
        confirmOrder: null
      }
    },
    settings: {
      homePageType: 1
    }
  };
};
import ImageSelection from "@/components/gallery/ImageSelection";
import Themes from "@/components/contactless/Theme";

export default {
  name: "Theme",
  components: {
    Themes,
    ImageSelection
  },
  props: {
    enable: {
      type: Boolean,
      default: false
    },
    id: {
      type: Number || null,
      default: null
    },
    themeInfo: {
      type: Object,
      required: true
    },
    images: {
      type: Array,
      required: true
    }
   
  },
  data() {
    return {
      tab: 0,
      accountId: parseInt(this.$route.params.accountId),
      field : "theme",
      themeId:""
    };
  },
  computed: {
    formIns() {
       if (!this.themeInfo.themes) { 
    
        
        let formIns = newFormIns(); 
        return formIns;
      }
      return this.themeInfo;
    }
  },  
  methods:{
    save() {  
        this.images.forEach((img) => {
            this.formIns.themes.images[img.id] = img.value;
        });
        this.loader = true;
     
        let url = `${this.ADMIN_API_URL}/accounts/${this.accountId}/contactless`;  

        let q;
        if (this.id) {
            q = this.$http.put(`${url}/${this.id}`, this.formIns);
        } else {
           
            // this.formIns.id = 0;
            q = this.$http.post(`${url}`, this.formIns);
        }
        q.then(
            (res) => {
            this.loader = false;
            this.$store.commit("showSnackbar", {
                timeout: 3000,
                message: res.body.message
            });
            this.close();
            },
            (failure) => {
            this.loader = false;
            this.handleFailure(failure);
            }
        );
    },
    close(){
      this.$emit("close");
    }
  }
};
</script>